<script>
	import { Basket } from "../lib/stores/basket";
	import { useParams } from "svelte-navigator";
	import { track } from 'fbq';
    import StarRating from '../lib/components/StarRating.svelte';
	const params = useParams();

    let feedbackSubmited = false;

	let order;
	let order_id;
	Basket.subscribe(b => {
		const urlParams = new URLSearchParams(window.location.search);
		
		if($params && $params.id)
		order_id = $params.id;
		else
		order_id = b.order_id;
		fetch(`https://crm.lamara.in/products/products/getorderbyid?order_id=${order_id}`).then(res => res.json()).then(res => {
			if(!res.error){
				order = res.data;
				
			}
		})
	})

    const submitReview = async () => {
        feedbackSubmited = true;
        /**
        {
            "order_id": 12345,
            "customer_name": "John Doe",
        "package_rating": 5,
            "delivery_rating": 4,
        "how_know_lamara": 1,  //here how know lamara option values(integers) of dropdown 1,2,3,4
            "items": [
                {
                    "item_name": "Sample Item 1",
                    "item_id": 6789,
                    "rating_value": 5,
                    "comments": "Great product!",
                
                },
                {
                    "item_name": "Sample Item 2",
                    "item_id": 6790,
                    "rating_value": 4,
                    "comments": "Good quality.",
            
                }
            ]
        */
        let res = await fetch('https://crm.lamara.in/products/products/savereviews', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: order.order_product_details.map(p => ({
                    item_name: p.item_name,
                    item_id: p.package,
                    rating_value: p.rating,
                    comments: p.feedback
                })),
                order_id:order.order_info.order_booking_id,
                customer_name: order.order_info.customer_name,
                package_rating: order.packaging,
                delivery_rating: order.delivery,
                how_know_lamara: order.source
            })
        })
        if(order.order_product_details.filter(p => p.rating >= 4).length == order.order_product_details.length){
            window.open('https://www.google.com/search?q=lamara&sxsrf=APq-WBt2AtiojiPgsihk_YgtfyvzCNX2RA%3A1643754078993&source=hp&ei=XrL5YaWxOuybseMPooe-0A4&iflsig=AHkkrS4AAAAAYfnAbtztyjd1xS5c6WPWhlcjAtCzwGUt&ved=0ahUKEwil2OWPxd_1AhXsTWwGHaKDD-oQ4dUDCAc&uact=5&oq=lamara&gs_lcp=Cgdnd3Mtd2l6EAMyDgguEIAEELEDEMcBEK8BMgUIABCABDIFCAAQgAQyBwguEIAEEAoyBwgAEIAEEAoyBQguEIAEMgcIABCABBAKMgUIABCABDIFCAAQgAQyBQguEIAEOgQIIxAnOhEILhCABBCxAxCDARDHARDRAzoICAAQgAQQsQM6BQgAELEDOg4ILhCABBCxAxDHARCjAjoICAAQsQMQgwE6CggAEIAEEIcCEBQ6CAguEIAEELEDOgsIABCABBCxAxCDAToOCC4QgAQQsQMQxwEQ0QM6CwgAEIAEELEDEMkDOgUIABCSAzoLCC4QgAQQsQMQgwFQAFjeE2CEGGgAcAB4AIABaYgB1QSSAQMzLjOYAQCgAQE&sclient=gws-wiz#', '_blank');
        }
    }
	
</script>
{#if order && order.order_info && order.order_info.Order_status == "Delivered"}

    {#if feedbackSubmited}
        <p>Thank you for submitting feedback.</p>
    {:else}
        <h5>Request you to rate the products</h5>
        <div class="row">
            <div class="col">Customer Name</div>
            <div class="col">{order.order_info.customer_name}</div>
        </div>
        <div class="row">
            <div class="col">Order ID</div>
            <div class="col">{order.order_info.order_booking_id}</div>
        </div>
        <div class="order-table">
            <div class="">
                <div class="row mobile-hide h-line">
                    <div class="col-md-4">
                        <b>Name
                        </b>
                    </div>
                    <div class="col-md-4">
                        <b>Rating
                        </b>
                    </div>
                    <div class="col-md-4">
                        <b>Comments
                        </b>
                    </div>
                </div>
                {#each order.order_product_details as item}
                    <div class="row h-line">
                        <div class="col-md-4 mobile-mb-15 col-12">
                            <div class="mobile-show mb-10">
                                <b>Name:
                                </b>
                            </div>
                            {item.item_name}
                        </div>
                        <div class="col-md-4 mobile-mb-15 col-12">
                            <div class="mobile-show mb-10">
                                <b>Rating:
                                </b>
                            </div>
                            <StarRating bind:rating={item.rating}/>
                        </div>
                        <div class="col-md-4 mobile-mb-15 col-12">
                            <div class="mobile-show mb-10">
                                <b>Comments:
                                </b>
                            </div>
                            <textarea class="form-control" bind:value={item.feedback}/>
                        </div>
                    </div>
                {/each}
                <div class="row h-line">
                    <div class="col-md-4 col-4 d-flex align-items-center">
                        Packaging
                    </div>
                    <div class="col-md-4 col-8">
                        <StarRating bind:rating={order.packaging}/>
                    </div>
                    <div class="col-md-4 col-5">
                        
                    </div>
                </div>
                <div class="row h-line">
                    <div class="col-md-4 col-4 d-flex align-items-center">
                        Delivery
                    </div>
                    <div class="col-md-4 col-8">
                        <StarRating bind:rating={order.delivery}/>
                    </div>
                    <div class="col-md-4 col-5">
                    </div>
                </div>
                <div class="row h-line">
                    <div class="col-md-4 col-12">How did you get to know about lamara?</div>
                    <div class="col-md-3 col-12">
                        <select bind:value={order.source} class="form-control mt-10">
                            <option value="">Choose One</option>
                            <option value="1">Friends & Family</option>
                            <option value="2">Google Search</option>
                            <option value="3">Instagram</option>
                            <option value="4">Facebook</option>
                            <option value="5">Others</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <button class="btn btn-primary" on:click|preventDefault={submitReview}>Submit</button>
	{/if}
{/if}

<style>

	.order-details {
		margin-bottom: 20px;
		font-family: var(--primary-font);
	}

	.order-table {
		margin: 30px 0;
		font-family: var(--primary-font);
	}

	.total-amount {
		font-family: var(--primary-font);
		color: #434343;
		font-weight: 600;
		font-size: 20px;
	}

	.total-paid {
		font-family: var(--primary-font);
		font-weight: 600;
		font-size: 20px;
		margin-bottom: 24px;
	}
	
	.my-4 {
		color: #434343;
	}

	.font-gray-dark {
		color: #434343;
	}

    :global(.mobile-show) {
        display: none;
    }

    .h-line {
        border-top: 1px solid #dee2e6;
        padding: 15px 0;
    }

    .mb-10 {
        margin-bottom: 10px;
    }

    .mobile-mb-15 {
        margin-bottom: 15px;
    }

    @media only screen and (min-width: 320px) and (max-width: 650px) {
        :global(.feedback) {
            min-width: 210px;
        }

        :global(.mobile-hide) {
            display: none;
        }

        :global(.mobile-show) {
            display: block;
        }

        .mt-10 {
            margin-top: 10px;
        }
    }
 </style>